/* Common Imports */

import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography, Tab, Tabs, Box } from "@material-ui/core";
import BuyerFaqs from "./BuyerFaqs";
import SellerFaqs from "./SellerFaqs";
import AgentFaqs from "./AgentFaqs";
import ReferralFaqs from "./ReferralFaqs";
import NriFaqs from "./NriFaqs";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "1rem 0rem 1rem 0rem",
  },
  sectionSubDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },
  tabsAndTitleContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "3rem",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "1.5rem",
    },
  },
  titleDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  title: {
    fontWeight: "400",
    fontSize: "2.125rem",
    lineHeight: "3rem",
    letterSpacing: "0.047rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "1.8rem",
    },
  },
  subHeading: {
    color: "#666666",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1rem",
    letterSpacing: "0.016rem",
    marginTop: "0.5rem",
    [theme.breakpoints.down("md")]: {
      marginTop: "0rem",
      marginBottom: "1.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "1rem",
      marginBottom: "1.5rem",
      lineHeight: "1.5rem",
    },
  },
  tabsCombined: {
    background: "#ffffff",
    color: "#343434",
    borderRadius: "4px",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
    "& .MuiTab-root": {
      minWidth: "auto",
      padding: "0.5rem 1rem",
    },
    "& .MuiTab-textColorInherit.Mui-selected": {
      background: "linear-gradient(90deg, #F74134 0%, #EB1C61 100%)",
      color: "#ffffff",
    },
    [theme.breakpoints.down("xs")]: {
      "& .MuiTabScrollButton-root.Mui-disabled": {
        display: "none",
      },
      width: "100%",
    },
  },
}));

/* Tab Panel MUI default Function */
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const SectionTwo = () => {
  const classes = useStyles();

  /* Tab Change Handling */
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <div className={classes.sectionSubDiv}>
          <div className={classes.tabsAndTitleContainer}>
            {/* Title */}
            <div className={classes.titleDiv}>
              <Typography
                variant="h6"
                component="span"
                className={classes.title}
              >
                Frequently Asked Questions
              </Typography>
              <Typography
                variant="body2"
                component="span"
                className={classes.subHeading}
              >
                Questions need answering, especially when they are asked
                frequently!
              </Typography>
            </div>

            {/* Tab Bar Desktop */}
            <Tabs
              variant="scrollable"
              className={classes.tabsCombined}
              value={value}
              onChange={handleChange}
              aria-label="FAQs"
              indicatorColor="primary"
              TabIndicatorProps={{
                style: {
                  height: 0,
                },
              }}
            >
              <Tab label="Buyer" {...a11yProps(0)} />
              <Tab label="Seller" {...a11yProps(1)} />
              <Tab label="Agent" {...a11yProps(2)} />
              <Tab label="Referral" {...a11yProps(3)} />
              <Tab label="NRI" {...a11yProps(4)} />
            </Tabs>
          </div>

          {/* Tabs Content */}
          <div style={{ width: "100%" }}>
            <TabPanel value={value} index={0}>
              <BuyerFaqs />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <SellerFaqs />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <AgentFaqs />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <ReferralFaqs />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <NriFaqs />
            </TabPanel>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SectionTwo;
